<template>
  <v-card content--fluid tile flat>
    <v-tabs
      v-model="tab"
      background-color="grey lighten-3"
      aria-selected="primary"
    >
      <v-tabs-slider></v-tabs-slider>
      <v-tab href="#processual" @click="routerLink('processual')">
        <v-icon>mdi-scale-balance</v-icon>
        <span class="font-weight-regular ml-2">
          PROCESSUAL
        </span>
      </v-tab>
      <v-tab href="#jurisprudencia" @click="routerLink(tabJurisprudencia)">
        <v-icon>mdi-gavel</v-icon>
        <span class="font-weight-regular ml-2">
          JURISPRUDÊNCIA
        </span>
      </v-tab>
      <v-spacer></v-spacer>
      <v-menu bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            class="mgrey--text font-weight-regular align-self-center mr-4 d-none d-sm-flex"
            v-bind="attrs"
            v-on="on"
            @click="abrirModalBusca"
          >
            <v-icon class="px-2">mdi-information-outline</v-icon>
            Sobre o busca TCDF
          </v-btn>
        </template>
        <v-card flat>
          <div>
            <sobre-busca ref="sobreBuscaComponent" />
            <v-divider></v-divider>
          </div>
        </v-card>
      </v-menu>
      <v-menu bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            class="mgrey--text font-weight-regular align-self-center mr-4 d-none d-sm-flex"
            v-bind="attrs"
            v-on="on"
            @click="redirectQuestionario()"
          >
            <v-icon class="px-2">mdi-thumb-up-outline</v-icon>
            avalie nosso serviço
          </v-btn>
        </template>
      </v-menu>
      <!-- <v-tab href="#tab-favoritos">
        <v-icon>mdi-star</v-icon>
        <span class="font-weight-regular ml-2">
          FAVORITOS
        </span>
      </v-tab> -->
    </v-tabs>
    <v-tabs-items v-model="tab">
      <!-- ABA DE BUSCA PROCESSUAL EXTERNA -->
      <v-tab-item value="processual">
        <busca-processual
          :historicoBuscaProcessual="historicoBuscaProcessual"
          :paramsProcessual="routerSplit"
        />
      </v-tab-item>
      <!-- ABA DE JURISPRUDENCIA -->
      <v-tab-item value="jurisprudencia">
        <jurisprudencia
          @redirectRoute="routerLink"
          :paramsJurisprudencia="routerSplit"
          :tabJurisp="tabJurisprudencia"
          :historicoJurisprudencia="historicoJurisprudencia"
          :paramsHref="paramsHref"
        />
      </v-tab-item>
      <!-- <v-tab-item value="tab-favoritos"> </v-tab-item> -->
    </v-tabs-items>
  </v-card>
</template>
<script>
import Vue from "vue";
import BuscaProcessual from "@/components/processual/BuscaProcessual";
import Jurisprudencia from "@/components/jurisprudencia/Jurisprudencia";
import _ from "lodash";
import moment from "moment";
import SobreBusca from "../shared/SobreBusca.vue";

export default {
  components: {
    SobreBusca,
    BuscaProcessual,
    Jurisprudencia
  },
  props: {
    isMobile: { type: Boolean, default: false }
  },
  data() {
    return {
      tab: "processual",
      tabJurisprudencia: "/jurisprudencia/todas-bases",
      historicoBuscaProcessual: {},
      historicoJurisprudencia: {},
      routerSplit: [],
      paramsJurisprudencia: [],
      paramsHref: {}
    };
  },
  created() {
    // console.log(window.location.href);
    this.routerSplit = this.$route.path.split("/");
    if (this.$route.path === "/") {
      this.tab = "processual";
      this.routerLink(`${this.$route.path}processual`);
    } else if (this.routerSplit[1] == "processual") {
      this.tab = "processual";
      this.routerLink(`${this.$route.path}`);
    } else {
      this.tab = "jurisprudencia";
      // this.paramsJurisprudencia.push(this.routerSplit);
      const splitHref = window.location.href.split("?");
      if (splitHref.length > 1) {
        this.routerHref = splitHref[1];
        const params = this.routerHref.split("&");
        this.paramsHref = {
          q: params[0],
          hash: params[1]
        };
      } else {
        this.paramsHref = {};
      }
      this.routerLink(this.$route.path);
    }

    this.historicoBuscaProcessual = JSON.parse(
      Vue.localStorage.get("historicoBuscaProcessual") || "{}"
    );
    this.historicoJurisprudencia = {
      historicoTodaBase: JSON.parse(
        Vue.localStorage.get("historicoTodaBase") || "{}"
      ),
      historicoInteiroTeor: JSON.parse(
        Vue.localStorage.get("historicoInteiroTeor") || "{}"
      ),
      historicoSelecionada: JSON.parse(
        Vue.localStorage.get("historicoSelecionada") || "{}"
      ),
      historicoBoletim: JSON.parse(
        Vue.localStorage.get("historicoBoletim") || "{}"
      )
    };
  },
  methods: {
    routerLink(route) {
      this.routerSplit = route.split("/");
      if (route == "processual") {
        window.location = `#${route}`;
      } else if (
        this.routerSplit[1] == "jurisprudencia" &&
        this.routerSplit.length == 3
      ) {
        this.tabJurisprudencia = `/${this.routerSplit[1]}/${this.routerSplit[2]}`;
        window.location = `#/${this.routerSplit[1]}/${this.routerSplit[2]}`;
      } else if (
        this.routerSplit[1] == "jurisprudencia" &&
        this.routerSplit.length > 3
      ) {
        this.tabJurisprudencia = `/${this.routerSplit[1]}/${this.routerSplit[2]}`;
        window.location = `#/${this.routerSplit[1]}/${this.routerSplit[2]}/${this.routerSplit[3]}`;
      }
    },
    redirectQuestionario() {
      window.open("https://forms.office.com/r/2xrseWXLvC", "_blank");
    },
    abrirModalBusca() {
      if (this.$refs.sobreBuscaComponent) {
        this.$refs.sobreBuscaComponent.abrirModal();
      }
    }
  }
};
</script>
